/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostawsauthverifysetupcompletePostBody
 */
export interface JumboPostawsauthverifysetupcompletePostBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostawsauthverifysetupcompletePostBody
     */
    userAccountID: string;
}

/**
 * Check if a given object implements the JumboPostawsauthverifysetupcompletePostBody interface.
 */
export function instanceOfJumboPostawsauthverifysetupcompletePostBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userAccountID" in value;

    return isInstance;
}

export function JumboPostawsauthverifysetupcompletePostBodyFromJSON(json: any): JumboPostawsauthverifysetupcompletePostBody {
    return JumboPostawsauthverifysetupcompletePostBodyFromJSONTyped(json, false);
}

export function JumboPostawsauthverifysetupcompletePostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostawsauthverifysetupcompletePostBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAccountID': json['userAccountID'],
    };
}

export function JumboPostawsauthverifysetupcompletePostBodyToJSON(value?: JumboPostawsauthverifysetupcompletePostBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userAccountID': value.userAccountID,
    };
}

